import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useTemplateDetailsModalStyles = makeStyles({
  dialog: {
    minWidth: '1030px',
    minHeight: '450px',
    '@media (max-width: 1030px)': {
      minWidth: 'max-content',
      minHeight: 'auto',
    },
  },
  dialogContentContainer: {
    display: 'flex',
    flexDirection: 'row',
    ...shorthands.gap(tokens.spacingHorizontalXXXL),
    ...shorthands.overflow('hidden', 'auto'),
    '@media (max-width: 1030px)': {
      flexDirection: 'column',
      minWidth: 'max-content',
      paddingBottom: tokens.spacingVerticalL,
    },
  },
  detailsContainer: {
    display: 'flex',
    width: '600px',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalL),
  },
  textGroup: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingHorizontalS),
  },
  errorMsg: {
    color: tokens.colorStatusDangerForeground1,
  },
  videoContainer: {
    display: 'flex',
    width: '600px',
    maxHeight: '450px',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
